<template>
    <div :class="'bwc--' + slice.primary.bwc_background_color">
        <div class="container">
            <section :class="'banner_with_caption ' + slice.slice_label">
                <div class="banner_image">
                    <div class="col-inner">
                        <div class="section has-hover">
                            <prismic-image :field="slice.primary.image_banner"/>
                        </div>
                    </div>
                </div>

                <div class="content">
                    <div class="col-inner">
                        <prismic-rich-text :field="slice.primary.title_of_banner"/>
                        <prismic-rich-text :field="slice.primary.description"/>
                        <template v-if="slice.primary.button_link !== ''">
                        <prismic-link class="button primary is-underline is-larger lowercase" :field="slice.primary.button_link"><span>{{ $prismic.richTextAsPlain(slice.primary.button_label) }}</span></prismic-link>
                        </template>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['slice'],
        name: "banner_with_caption"
    }
</script>

<style lang="scss">
    .bwc {
        &--blue {
            padding-top: 50px;
            padding-bottom: 50px;
            margin-bottom: 5rem;
            background: #117096;
            & h2,
            & .primary.is-underline, .primary.is-link, .primary.is-outline,
            & .content {
                color: #fff;
            }
            & .banner_with_caption.text_left {
                & .banner_image {
                    padding: 0;
                    .col-inner {
                        z-index: 0;
                        .section {
                            padding: 0;
                            img {
                                width: 100%;
                            }
                        }
                    }
                    & .section.has-hover:before {
                        content: "";
                        background-color: #e7ecff;
                        /*border-width: 30px 30px 0px 0px;*/
                        margin: -30px -30px 30px 30px;
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        z-index: -1;
                        border-width: 0;
                        border-style: solid;
                        border-color: #ececec;
                        position: absolute;
                        pointer-events: none;
                        border-radius: 0;
                    }
                }
            }
        }
    }
    .banner_with_caption {
        display: flex;
        width: 100%;
        align-items: center;

        &.text_right {
            flex-direction: row;
            @media (max-width:768px) {
                flex-direction: column;
            }
            & .content,
            & .banner_image {
                max-width: 50%;
                -ms-flex-preferred-size: 50%;
                flex-basis: 50%;
                position: relative;
                margin: 0;
                padding: 0 30px;
                width: 100%;
                @media (max-width:768px) {
                    max-width: calc(100% - 60px);
                    -ms-flex-preferred-size: 100%;
                    flex-basis: 100%;
                }
            }
            & .col-inner {

            }
            & .banner_image {
                & .col-inner {

                    & .section {
                        img {
                            width: 100%;
                        }
                    }
                }
            }
        }
        &.text_left {
            flex-direction: row-reverse;
            @media (max-width:768px) {
                flex-direction: column;
            }
            & .content,
            & .banner_image {
                max-width: 50%;
                -ms-flex-preferred-size: 50%;
                flex-basis: 50%;
                position: relative;
                margin: 0;
                padding: 0 30px 30px;
                width: 100%;
                @media (max-width:768px) {
                    max-width: calc(100% - 60px);
                    -ms-flex-preferred-size: 100%;
                    flex-basis: 100%;
                }
            }
            & .col-inner {

            }
            & .banner_image {
                & .col-inner {
                    & .section {

                    }
                }
            }
        }
        &.text_below {
            flex-direction: column;
        }
        &.text_above {
            flex-direction: column-reverse;
        }
        & .content {
            flex-direction: column;
        }
    }
</style>
